import { Link } from 'react-router-dom';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryEntries from '@/pages/home/components/CategoryEntries';
import HotRecommend from '@/pages/home/components/HotRecommend';
import NewsCard from '@/components/base/NewsCard';
import SectionHeading from '@/components/base/SectionHeading';
import { news } from '@/mocks/news';
import { works } from '@/mocks/works';

export default function Home() {
  const latestNews = [...news].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 6);
  const ranking = [...works].sort((a, b) => a.rank - b.rank).slice(0, 6);

  return (
    <div className="w-full">
      <HeroCarousel />

      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          eyebrow="快速入口"
          title="影视分类快捷入口"
          desc="想看电影还是追剧？从两大分类出发，快速找到属于你的下一部心头好。"
        />
        <CategoryEntries />
      </div>

      <section id="latest-news" className="w-full bg-background-100 py-10 md:py-14">
        <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
          <SectionHeading
            eyebrow="最新动态"
            title="最新影视资讯"
            desc="按时间倒序为你汇集影坛与剧集圈的新鲜事，第一时间掌握影视动态。"
          />
          {latestNews.length === 0 ? (
            <div className="rounded-lg border border-background-200 bg-background-50 py-16 text-center text-foreground-500">
              暂无相关内容，敬请期待
            </div>
          ) : (
            <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
              <div className="flex flex-col gap-4 lg:col-span-2">
                {latestNews.map((item) => (
                  <NewsCard key={item.id} item={item} />
                ))}
              </div>

              <aside className="lg:col-span-1">
                <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
                  <div className="mb-4 flex items-center gap-2">
                    <i className="ri-fire-fill text-lg text-accent-500" />
                    <h3 className="font-heading text-lg font-bold text-foreground-950">热门榜单</h3>
                  </div>
                  <ul className="space-y-3">
                    {ranking.map((w, i) => (
                      <li key={w.id}>
                        <Link to={`/detail/${w.id}`} className="group flex items-center gap-3">
                          <span
                            className={`flex h-6 w-6 shrink-0 items-center justify-center rounded text-xs font-bold ${
                              i < 3 ? 'bg-accent-500 text-background-50' : 'bg-secondary-100 text-secondary-900'
                            }`}
                          >
                            {i + 1}
                          </span>
                          <span className="min-w-0 flex-1 truncate text-sm text-foreground-800 group-hover:text-primary-600">
                            {w.title}
                          </span>
                          <span className="shrink-0 text-xs font-semibold text-accent-600">{w.rating.toFixed(1)}</span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </aside>
            </div>
          )}
        </div>
      </section>

      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          eyebrow="精选推荐"
          title="热门影视推荐"
          desc="综合评分、热度与口碑，为你挑选当下最值得一看的电影与电视剧。"
          moreTo="/search"
          moreLabel="搜索更多"
        />
        <HotRecommend />
      </div>

      <section className="w-full bg-primary-900 py-12 md:py-16">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-start gap-6 px-4 md:flex-row md:items-center md:justify-between md:px-6">
          <div className="max-w-2xl">
            <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">关于枫与铃</h2>
            <p className="mt-3 text-sm leading-relaxed text-primary-100 md:text-base">
              枫与铃致力于提供最新的影视剧资讯和推荐，涵盖电影、电视剧等多种影视作品，帮助用户快速了解和选择喜爱的影视内容。我们希望成为你打开影视世界的第一站。
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
            >
              了解我们
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/category/movie"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-300/50 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-800"
            >
              浏览片库
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}